/**
 * Testimonials carousel with navigation.
 */
class TestimonialsCarousel extends HTMLElement {
  constructor() {
    super();
    this.slides = this.querySelectorAll('.testimonials__slide');
    this.prevButton = this.querySelector('[data-prev]');
    this.nextButton = this.querySelector('[data-next]');
    this.dots = this.querySelectorAll('.testimonials__dot');
    this.currentIndex = 0;
    this.autoplayTimer = null;
  }

  connectedCallback() {
    if (this.slides.length === 0) return;

    this.slides[0].classList.add('is-active');

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.prev());
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.next());
    }

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goTo(index));
    });

    // Auto-advance every 6 seconds
    this.startAutoplay();
  }

  goTo(index) {
    if (index === this.currentIndex) return;

    this.slides[this.currentIndex].classList.remove('is-active');
    this.slides[index].classList.add('is-active');

    if (this.dots.length > 0) {
      this.dots[this.currentIndex].classList.remove('is-active');
      this.dots[index].classList.add('is-active');
    }

    this.currentIndex = index;
    this.resetAutoplay();
  }

  next() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.goTo(nextIndex);
  }

  prev() {
    const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.goTo(prevIndex);
  }

  startAutoplay() {
    this.autoplayTimer = setInterval(() => this.next(), 6000);
  }

  resetAutoplay() {
    clearInterval(this.autoplayTimer);
    this.startAutoplay();
  }
}

customElements.define('testimonials-carousel', TestimonialsCarousel);
